








































import { Component, Vue } from "vue-property-decorator";
import { replyUser } from "@/req/user";
@Component
export default class Home extends Vue {
  public data: any = [];
  public page = 1;
  public pageSize = 10;
  public display = false;
  public created() {
    /* if (!this.$fn.cookies.getToken()) {
      return false;
    } */
    this.getList();
  }
  // 获取列表
  public async getList() {
    // this.display = false;
    const res = await replyUser({
      token: this.$fn.cookies.getToken(),
      page: this.page,
      size: this.pageSize,
    });
    if (res.code == 200) {
      this.data = res.data.replyData;
      if (this.data.data.length != 0) {
        this.display = true;
      } else {
        this.display = false;
      }
    }
  }
  public changepage(index) {
    this.page = index;
    this.getList();
  }
}
